
import { Component, Prop, Vue } from 'vue-property-decorator'
import LabelBase from '@/components/atoms/LabelBase.vue'
import LinkBase from '@/components/atoms/LinkBase.vue'
import PanelFrame from '@/components/molecules/PanelFrame.vue'
import ButtonLogin from '@/components/molecules/ButtonLogin.vue'

/**
 * ログインパネル
 */
@Component({
  components: {
    LabelBase,
    LinkBase,
    PanelFrame,
    ButtonLogin,
  },
})
export default class LoginPanel extends Vue {
  /** ログインボタン押下時のイベント */
  @Prop()
  private eventLogin!: () => void

  /** パスワードリマインダへのリンク */
  @Prop()
  private reminderLink?: string

  /** 仮ユーザログインへのリンク */
  @Prop()
  private activateLink?: string

  /** ログインID */
  public loginId: string = ''

  /** パスワード */
  public password: string = ''

  /**
   * 入力チェック
   *
   * @returns ID/Passwordともに入力済みならtrue
   */
  private get isBlanked(): boolean {
    return this.loginId === '' || this.password === ''
  }
}
